import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";

export default function Contact() {

  const getCurrentYear = () => {
    return new Date().getFullYear();
  }

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "30px 0" }}>
            <Link className="flexCenter animate pointer" to="home" smooth={true} offset={-80}>
              <img src="/SECONDARY%20WHITE.png" alt="ClickLaw" style={{ height: 36 }} />
            </Link>

            <SocialRow aria-label="Social links">
              <SocialLink
                href="https://www.tiktok.com/@clicklaww"
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                title="TikTok"
              >
                <TikTokIcon aria-hidden="true" />
              </SocialLink>
              <SocialLink
                href="https://www.linkedin.com/company/clicklaww"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                title="LinkedIn"
              >
                <LinkedInIcon aria-hidden="true" />
              </SocialLink>
              <SocialLink
                href="https://clicklaw.tech/"
                target="_blank"
                rel="noreferrer"
                aria-label="Website"
                title="Website"
              >
                <GlobeIcon aria-hidden="true" />
              </SocialLink>
              <SocialLink
                href="https://web.facebook.com/profile.php?id=61580800284878"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                title="Facebook"
              >
                <FacebookIcon aria-hidden="true" />
              </SocialLink>
            </SocialRow>

            <StyleP className="whiteColor font13">
              © {getCurrentYear()} - <span className="purpleColor font13">ClickLaw</span> All Right Reserved
            </StyleP>

            <Link className="whiteColor animate pointer font13" to="home" smooth={true} offset={-80}>
              Back to top
            </Link>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;

const SocialRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  @media (max-width: 550px) {
    margin: 14px 0;
  }
`;

const SocialLink = styled.a`
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.85);

  :hover {
    border-color: #d4af37;
    color: #d4af37;
  }
`;

const IconBase = (props) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...props} />
);

const FacebookIcon = (props) => (
  <IconBase {...props}>
    <path
      d="M14 8.5h2V6h-2c-1.66 0-3 1.34-3 3v2H9v2.5h2V20h2.5v-6.5H16L16.5 11H13.5V9c0-.28.22-.5.5-.5Z"
      fill="currentColor"
    />
  </IconBase>
);

const LinkedInIcon = (props) => (
  <IconBase {...props}>
    <path
      d="M6.94 6.5a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0ZM4.5 9h2.88v10H4.5V9ZM10 9h2.76v1.37h.04c.38-.72 1.32-1.49 2.72-1.49 2.91 0 3.45 1.92 3.45 4.41V19h-2.88v-5.14c0-1.23-.02-2.8-1.71-2.8-1.71 0-1.97 1.33-1.97 2.71V19H10V9Z"
      fill="currentColor"
    />
  </IconBase>
);

const TikTokIcon = (props) => (
  <IconBase {...props}>
    <path
      d="M15 3c.3 2.27 1.72 3.9 4 4.2V9.8c-1.35 0-2.57-.42-3.63-1.14V14c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6c.2 0 .4.01.6.04v2.78c-.2-.06-.4-.1-.6-.1-1.77 0-3.2 1.43-3.2 3.2s1.43 3.2 3.2 3.2 3.2-1.43 3.2-3.2V3h2.43Z"
      fill="currentColor"
    />
  </IconBase>
);

const GlobeIcon = (props) => (
  <IconBase {...props}>
    <path
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm7.93 9h-3.24a15.7 15.7 0 0 0-1.02-4.06A8.02 8.02 0 0 1 19.93 11ZM12 4c.9 1.1 1.62 2.88 2.03 5H9.97C10.38 6.88 11.1 5.1 12 4ZM4.07 13h3.24c.2 1.46.6 2.83 1.02 4.06A8.02 8.02 0 0 1 4.07 13ZM7.31 11H4.07a8.02 8.02 0 0 1 4.26-4.06c-.42 1.23-.82 2.6-1.02 4.06Zm2.66 2h4.06c-.41 2.12-1.13 3.9-2.03 5-.9-1.1-1.62-2.88-2.03-5Zm5.7 4.06c.42-1.23.82-2.6 1.02-4.06h3.24a8.02 8.02 0 0 1-4.26 4.06ZM16.69 11c-.2-1.46-.6-2.83-1.02-4.06A8.02 8.02 0 0 1 19.93 11h-3.24Z"
      fill="currentColor"
    />
  </IconBase>
);